/**
 * `GET /tabs/all`（設定用タブ一覧）の TanStack Query キー。
 * `TabConfigScreen` とデータ更新関連コンポーネントの両方から invalidate されるため、
 * リテラルの再記述による typo を避けるためにここで一元管理する。
 */
export const allTabsQueryKey = (accountId: string): readonly [string, string] => [
  'custom-dashboard-all-tabs',
  accountId,
];
